/*
 * Copyright (C) 2017-present Connection Loops Pvt. Ltd., Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

/*eslint-disable  no-useless-escape*/

import { EntityDetailsTypeLabel } from "common_assets/Constants/constants";
import { ICLDropDownOptions } from "components/common";

export const getUrlParametersByName = (
  name: string,
  url?: string
): string | null => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export function pad2(num: number) {
  return (num < 10 ? "0" : "") + num;
}

export const getDateInIndianFormat = (dtIn: string): string => {
  if (dtIn != null) {
    return (
      getOnlyDateInIndianFormat(dtIn) + " " + getOnlyTimeInIndianFormat(dtIn)
    );
  } else {
    return "";
  }
};
export const getOnlyDateInIndianFormat = (dtIn: string): string => {
  if (dtIn != null) {
    const dtObj = new Date(dtIn);
    return (
      pad2(dtObj.getDate()) +
      "/" +
      pad2(dtObj.getMonth() + 1) +
      "/" +
      dtObj.getFullYear()
    );
  } else {
    return "";
  }
};
export const getOnlyTimeInIndianFormat = (dtIn: string): string => {
  if (dtIn != null) {
    const dtObj = new Date(dtIn);
    return (
      pad2(dtObj.getHours()) +
      ":" +
      pad2(dtObj.getMinutes()) +
      ":" +
      pad2(dtObj.getSeconds())
    );
  } else {
    return "";
  }
};

export const clStringToDate = (date: string): Date => {
  if (!date) {
    return new Date();
  }
  let dateTimeParts: string[] = date.split(" ");
  let dateParts: string[] = dateTimeParts[0].split("/");
  if (dateTimeParts.length === 1) {
    return new Date(
      parseInt(dateParts[2]),
      parseInt(dateParts[1]),
      parseInt(dateParts[0])
    );
  }
  let timePart: string[] = dateTimeParts[1].split(":");
  if (dateTimeParts.length === 2) {
    return new Date(
      parseInt(dateParts[2]),
      parseInt(dateParts[1]),
      parseInt(dateParts[0]),
      parseInt(timePart[0]),
      parseInt(timePart[1]),
      parseInt(timePart[2])
    );
  }
  return new Date();
};
// used by date pickers to convert date to string to display in text box
export const formatDate = (dt: Date | any) => {
  if (dt.getFullYear() === 1900) {
    // epoch date means no date input
    return "";
  }
  // this doesn't consider time
  return getDateInIndianFormat(dt.toISOString()).split(" ")[0];
};

export const getPaymentOptions = (): ICLDropDownOptions[] => {
  const paymentOptions: ICLDropDownOptions[] = [
    {
      Id: "CASH",
      Text: "Cash",
    },
    {
      Id: "Card",
      Text: "Card",
    },
    {
      Id: "Cheque",
      Text: "Cheque",
    },
    {
      Id: "DD",
      Text: "DD",
    },
    {
      Id: "Online",
      Text: "Online",
    },
    {
      Id: "PayTM Wallet",
      Text: "PayTM Wallet",
    },
    {
      Id: "PayTM UPI",
      Text: "PayTM UPI",
    },
    {
      Id: "GPay",
      Text: "Google Pay",
    },
    {
      Id: "PhonePe",
      Text: "PhonePe",
    },
    {
      Id: "BHIM UPI",
      Text: "BHIM UPI",
    },
  ];
  return paymentOptions;
};

export const getCategoryOptions = (): ICLDropDownOptions[] => {
  return Object.keys(EntityDetailsTypeLabel).map((h) => ({
    Id: h,
    Text: EntityDetailsTypeLabel[h],
  })) as ICLDropDownOptions[];
};

export const formatDateTime = (dt: Date) => {
  if (dt.getFullYear() === 1900) {
    // epoch date means no date input
    return "";
  }
  // this doesn't consider time
  return getDateInIndianFormat(dt.toISOString());
};

export const parseDateTimeFromString = (str: string): Date => {
  const dtPart = str.split(" ")[0].split("/");
  const tPart = str.split(" ")[1].split(":");
  const dt = new Date(
    parseInt(dtPart[2], 10),
    parseInt(dtPart[1], 10) - 1,
    parseInt(dtPart[0], 10),
    parseInt(tPart[0], 10),
    parseInt(tPart[1], 10),
    parseInt(tPart[2], 10)
  );
  return dt;
};

// used by date pickers to convert string to date to select in expanded panel and to value
export const parseDateFromString = (str: string): Date => {
  // console.log("PDS : " + str);
  try {
    if (str === "") {
      return new Date();
    }
    // this discards time
    const dtPart = str.split(" ")[0].split("/");
    const dt = new Date(
      parseInt(dtPart[2], 10),
      parseInt(dtPart[1], 10) - 1,
      parseInt(dtPart[0], 10)
    );
    return dt;
  } catch (ex) {
    // console.log("Failed to parse given date. str is " + str + "returning default string ");
    return new Date(1900, 0, 1); // empty date for us
  }
};
export const updateQueryStringParameter = (
  key: string,
  value: any,
  url?: string
) => {
  if (!url) {
    url = window.location.href;
  }
  const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  const separator = url.indexOf("?") !== -1 ? "&" : "?";

  url = url.match(re)
    ? url.replace(re, "$1" + key + "=" + value + "$2")
    : (url = url + separator + key + "=" + value);

  // Update only query string , does not reload the page
  window.history.pushState({}, "", url);
};

export const getValidationResult = (validationObject: any) => {
  let op = true;
  for (const bit in validationObject) {
    if (validationObject.hasOwnProperty(bit)) {
      op = op && validationObject[bit];
    }
  }
  if (!op) {
    console.log("Validation Failed : " + JSON.stringify(validationObject));
  }
  return op;
};

export const DictionaryToArray = (
  obj: any,
  keyField?: string,
  valueField?: string
) => {
  const _kf = keyField !== undefined ? keyField : "key";
  const retVal: any[] = [];
  for (const prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      const iter_obj = obj[prop];
      if (iter_obj !== null && typeof iter_obj === "object") {
        iter_obj[_kf] = prop;
        retVal.push(iter_obj);
      } else {
        const newObject: any = {};
        newObject[_kf] = prop;
        newObject[valueField !== undefined ? valueField : "value"] = iter_obj;
        retVal.push(newObject);
      }
    }
  }
  return retVal;
};

export const ArrayToDictionary = (arr: any[], keyField: string) => {
  let i = arr.length;
  const retVal: any = {};
  while (i--) {
    if (arr[i] && typeof arr[i] === "object") {
      retVal[arr[i][keyField]] = arr[i];
    }
  }
  return retVal;
};

export const setValidationBit = (
  validationobject?: any,
  bit?: string | undefined,
  appendValue?: boolean | undefined
) => {
  if (appendValue !== undefined) {
    validationobject[bit!] = appendValue;
  }
};

export function checkIsInt(value: string) {
  return /^\d+$/.test(value);
}
export function hasNumber(value: string) {
  return /\d/.test(value);
}
export const copyObj = (src: any) => {
  const dest: any = {};
  for (const prop in src) {
    if (src.hasOwnProperty(prop)) {
      dest[prop] = typeof prop === "object" ? copyObj(src[prop]) : src[prop];
    }
  }
  return dest;
};

export const copyObjRec = (src: any) => {
  const dest: any = {};
  for (const prop in src) {
    if (src.hasOwnProperty(prop)) {
      dest[prop] =
        typeof src[prop] === "object" ? copyObj(src[prop]) : src[prop];
    }
  }
  return dest;
};
export const getObjFromArray = (
  src: any,
  attributeName: string,
  val: string | number,
  insensitive?: boolean
) => {
  let i = src.length;
  while (i--) {
    if (insensitive === true && typeof val !== "number") {
      if (
        src[i] &&
        src[i].hasOwnProperty(attributeName) &&
        src[i][attributeName].toString().toUpperCase() ===
          val.toString().toUpperCase()
      ) {
        return src[i];
      }
    } else {
      if (
        src[i] &&
        src[i].hasOwnProperty(attributeName) &&
        src[i][attributeName].toString() === val.toString()
      ) {
        return src[i];
      }
    }
  }
};

export const deleteObj = (
  src: any,
  attributeName: string,
  val: string | number
) => {
  let i = src.length;
  while (i--) {
    if (
      src[i] &&
      src[i].hasOwnProperty(attributeName) &&
      src[i][attributeName] === val
    ) {
      src.splice(i, 1);
    }
  }
};

export const getCharValueFromKeyCode = (keycode: number): string | null => {
  switch (keycode) {
    case 48:
    case 96:
      return "0";
    case 49:
    case 97:
      return "1";
    case 50:
    case 98:
      return "2";
    case 51:
    case 99:
      return "3";
    case 52:
    case 100:
      return "4";
    case 53:
    case 101:
      return "5";
    case 54:
    case 102:
      return "6";
    case 55:
    case 103:
      return "7";
    case 56:
    case 104:
      return "8";
    case 57:
    case 105:
      return "9";
    default:
      return null;
  }
};

export const getRoundedVal = (val: any, decimalPlaces: any): string => {
  if (!isNaN(val)) {
    val = parseFloat(val).toFixed(decimalPlaces);
  }
  return val;
};

export const SYSTEMlogout = (): void => {
  window.location.href = "/logout";
};

export const GetTextTags = () => {
  return [
    "span",
    "div",
    "td",
    "li",
    "i",
    "b",
    "strong",
    "p",
    "em",
    "mark",
    "small",
    "del",
    "ins",
    "sub",
    "sup",
    "br",
  ];
};

/**
 * This function modifies default font size based on labsswitches
 *
 * if div or span does not have font size it will not touch
 * @param html
 * @param multi
 * @param defFS
 * @param defaultFontFamily
 */

export const spacifySpans = (span: any): void => {
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < span.childNodes.length; i++) {
    if (span.childNodes[i].nodeName !== "#text") {
      // non text node; recur
      spacifySpans(span.childNodes[i]);
    } else {
      // base condition
      span.childNodes[i].textContent = span.childNodes[i].textContent.replace(
        / /g,
        "~!@#"
      );
    }
  }
};

export const getUUID = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
};

export const COMP_LOADER_TIMEOUT = 60000;

export const bytesToStr = (bytes: any, si: any) => {
  const thresh = si ? 1000 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }
  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1) + " " + units[u];
};

export const isJson = (str: string) => {
  try {
    const obj = JSON.parse(str);
    return Object.keys(obj).length > 0;
  } catch (e) {
    return false;
  }
};

export const getAgoTime = (date: Date) => {
  let today: Date = new Date();
  // @ts-ignore
  let seconds: any = Math.floor((today - date) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
};

export const AgeInYears = (age_sex: any) => {
  const aunit = age_sex.unit;
  const age = age_sex.age;
  switch (aunit) {
    case "Yrs.":
      return age;
    case "Months":
      return age / 12.0;
    case "Week(s)":
      return age / 52.0;
    case "Days":
      return age / 365.0;
    case "Hrs.":
      return age / 8760.0;
  }
};

export const GLOBAL_ALL_OPTION_OPTION_TYPE: any = {
  value: "all",
  label: "ALL",
};

export const dataURItoBlob = (dataURI: any) => {
  // convert base64 to raw binary data held in a string
  const byteString = atob(dataURI.split(",")[1]);

  // separate out the mime component
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to an ArrayBuffer
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const _ia = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    _ia[i] = byteString.charCodeAt(i);
  }

  const dataView = new DataView(arrayBuffer);
  return new Blob([dataView], { type: mimeString });
};
